import React, {Component} from "react";
import {connect} from "react-redux";
import {compose, lifecycle} from "recompose";
import {forEach, isEmpty, concat, uniqBy, map} from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import {Button, FontIcon} from "react-md";

import Header from "../../components/ContainerHeader";
import RequestDetailInfo from "./RequestDetailInfo";
import RequestDetailNewComment from "./RequestDetailNewComment";
import RequestDetailComments from "./RequestDetailComments";

import {getUser} from "../../actions/userActions";
import {
    getProjects,
    getAdminOrganizations,
    getDispatcherOrganizations
} from "../../actions/resourceActions";
import {getRequestById} from "../../actions/requestActions";
import {setActiveForm} from "../../actions/appActions";

import {minutesToDaysHoursMinutes} from "../../utils/index";
import {DebugElement} from "../../Atollon/debug";
import {requestStatusBackgroundColor} from "../../enums/index";
import {RequestModel2017} from "./RequestModel2017";
import {RequestModelOriginal} from "./RequestOldModel";
import * as storage from "../../utils/storage";

function log()
{
    console.log.apply( null, concat( ['%cRequestDetail', 'color:white;background:green;'], arguments ) );
}

function isDebugStates()
{
    if( window.location.search.match(/debug=(1|true)/))
    {
        storage.set( 'debugRequestDetail', 1 );
    }
    else if( window.location.search.match(/debug=(0|false)/))
    {
        storage.set( 'debugRequestDetail', 0 );
    }

    const isDebug = storage.get( 'debugRequestDetail' ) === "1";
    log({ isDebug });
    if( isDebug )
    {
        return true;
    }
    else
    {
        return false;
    }
}

class RequestDetail extends Component
{
    render()
    {
        let {
            history,
            request,
            projects,
            user,
            match,
            setActiveForm,
            organizationsAdmin,
            organizationsDispatcher,
            state
        } = this.props;
        let {app: {form: {activeForm, activeFormData}}} = state;




        if( !request )
        {
            return <div/>;
        }


        let providerOrganizations;
        if(
            organizationsAdmin &&
            organizationsAdmin.item &&
            organizationsDispatcher &&
            organizationsDispatcher.item
        )
        {
            providerOrganizations = uniqBy(
                concat( organizationsAdmin.item, organizationsDispatcher.item ),
                "identifier"
            );
        }
        else if( organizationsAdmin )
        {
            providerOrganizations = organizationsAdmin.item;
        }
        else if( organizationsDispatcher )
        {
            providerOrganizations = organizationsDispatcher.item;
        }

        const __ret = RequestModel2017( {request, setActiveForm, match} );
        let {result: {primaryButtons, buttons}, debugChosenCase} = __ret;
        let headerTitle2017 = __ret.result.headerTitle;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        let headerTitle = RequestModelOriginal.getHeaderForRequest( request );
        const commands = RequestModelOriginal.getCommandsForRequest( request );
        let leftButtons = [];
        let rightButtons = [];

        log( 'RequestModel2017', __ret );
        log( 'RequestModel Orig commands', commands );

        let debugCommands2017 = [];
        let Debug = () => <div/>;
        if( isDebugStates() )
        {
            Debug = () => (
                <div>
                    <h2>new</h2>
                    <table>
                        <tr>
                            <td>isPrimary</td>
                            <td>name</td>
                            <td>formData</td>
                            <td>primaryButtonLabel</td>
                        </tr>
                        {map( commands, ( item ) =>
                        {
                            return (
                                <tr>
                                    <td>{item.isPrimary ? 'true' : ''}</td>
                                    <td>{item.name}</td>
                                    <td>{map( item.formData, ( v, k ) => <div>{k}={v}</div> )}</td>
                                </tr>

                            )
                        } )}
                        <tr>
                            <td><h2>2017</h2></td>
                        </tr>
                        {map( __ret.result.buttons, ( item ) =>
                        {
                            return <tr>
                                <td></td>
                                <td>{item.label}</td>
                                <td>
                                    {item.onClick.toString()}
                                </td>
                                <td>
                                    {item.primaryButtonLabel}
                                </td>
                            </tr>;
                        } )}
                        {map( __ret.result.primaryButtons, ( item ) =>
                        {
                            return <tr>
                                <td>true</td>
                                <td>{item.label}</td>
                                <td>
                                    {item.onClick.toString()}
                                </td>
                                <td>
                                    {item.primaryButtonLabel}
                                </td>
                            </tr>;
                        } )}
                    </table>
                </div>
            );
        }

        log( 'RequestModel 2017 commands', __ret.result.buttons );
        log( 'headers are same', headerTitle2017 === headerTitle );
        let debugState = `status(${request.status}) pendingSide(${request.pendingSide}) type(${request.type}) title(${headerTitle})`;

        log( {activeFormData });

        forEach( commands, ( cmd, i ) =>
        {
            let setActiveFormData = {
                formData: cmd.formData, // For example: {status: "CLOSED"} ...
            };
            if( cmd.primaryButtonLabel )
            {
                setActiveFormData.primaryButtonLabel = cmd.primaryButtonLabel;
            }
            setActiveFormData.selectedRequestCommandID = cmd.id;

            let isHightlighted;
            //
            if( activeFormData && activeFormData.selectedRequestCommandID )
            {
                isHightlighted = activeFormData.selectedRequestCommandID === cmd.id;
            }
            else
            {
                isHightlighted = cmd.isPrimary;
            }

            const className = `btn btn-primary ${isHightlighted ? 'touchButton-6' : 'touchButton-5'}`;
            const button = <Button
                key={i}
                raised
                label={cmd.name}
                className={className}
                onClick={() =>
                {
                    debugger;
                    setActiveForm( "requestContentForm", setActiveFormData );
                    getRequestById( match.params.id );
                }}
            />;
            if( cmd.isPrimary )
            {
                rightButtons.push( button );
            }
            else
            {
                leftButtons.push( button );
            }
        } );
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        let buttonArray2ReactButtonArray = ( buttonArray, buttonClassName ) =>
        {
            let array = null;
            if( !isEmpty( buttonArray ) )
            {
                array = [];
                forEach( buttonArray, ( item, uniqueKey ) =>
                {
                    array.push( (
                        <Button
                            key={uniqueKey}
                            raised
                            className={"btn btn-primary " + buttonClassName}
                            label={item.label}
                            onClick={item.onClick}
                        />
                    ) );
                } );
            }
            return array;
        };

        let primaryButtonsReact = buttonArray2ReactButtonArray( primaryButtons, "touchButton-6" );
        let buttonsReact = buttonArray2ReactButtonArray( buttons, "touchButton-5" );

        const editing = activeForm === "requestContentForm";
        const show = {
            header: true, // ! editing
            comments: true, // !editing && !isEmpty( request.changeSets );
            commentsQuickComment: !editing //
        };

        let HeaderOriginal = () => <div/>;
        {
            HeaderOriginal = () =>
            {
                return ( show.header ? (
                            <div className={"touchRequestDetail-headerPadding"}>

                                <div
                                    className={"touchRequestDetail-status " + requestStatusBackgroundColor( request.status )}>{headerTitle}</div>
                                <div style={{padding: '18px 0', fontSize: 0}}>
                                    <div style={{textAlign: 'right'}}>
                                        {leftButtons}
                                        <div style={{display: 'inline-block', 'width': '18px'}}/>
                                        {rightButtons}
                                    </div>
                                </div>
                            </div>
                        )
                        : null
                );
            }
        }

        let Header2017 = () => <div/>;
        if( isDebugStates())
        {
            Header2017 = () => (show.header ? (
                <div className={"touchRequestDetail-headerPadding"}>
                    <div
                        className={"touchRequestDetail-status " + requestStatusBackgroundColor( request.status )}>{headerTitle2017}**** DEBUG
                    </div>
                    <div style={{padding: '18px 0', fontSize: 0}}>
                        <div style={{textAlign: 'right'}}>
                            {buttonsReact}
                            <div style={{display: 'inline-block', 'width': '18px'}}/>
                            {primaryButtonsReact}
                        </div>
                    </div>
                </div>
            )
            : null
            );
        }

        return (
            <div className="touchRequestDetail">

                {isDebugStates()? debugState : null }

                <DebugElement text={"src/containers/RequestDetail.js"}/>

                <HeaderOriginal/>
                <Header2017 />

                <DebugElement text={"--Content--"}/>

                <Debug/>

                <RequestDetailInfo
                    initialValues={{
                        priceAmount: request.priceAmount,
                        priceCurrency: request.priceCurrency ? request.priceCurrency : "CZK",
                        priceTaxAmount: request.priceTaxAmount,
                        withOrWithoutTax: "WITHOUT_TAX",
                        customType: request.customType,
                        severity: "" + request.severity,
                        project: request.project ? request.project.identifier : "NO_PROJECT",
                        ...minutesToDaysHoursMinutes( request.estimatedDuration )
                    }}
                    {...request}
                    {...{request, projects, history, user, providerOrganizations}}
                />

                <DebugElement text={"--NewComment--"}/>

                {show.commentsQuickComment ?
                    <RequestDetailNewComment request={request} user={user}/>
                    : null
                }

                <DebugElement text={"--RequestDetailComments--"}/>

                {show.comments ?
                    <RequestDetailComments
                        comments={request.changeSets}
                        priceCurrency={request.priceCurrency}
                        status={request.status}
                    />
                    : null
                }
            </div>
        );
    }
}

export default compose(
    connect(
        ( state ) =>
        {
            let {
                app: {user},
                request: {request},
                resource: {projects, organizationsAdmin, organizationsDispatcher}
            } = state;
            return {
                user,
                request,
                projects,
                organizationsAdmin,
                organizationsDispatcher,
                state
            };
        },
        {
            getRequestById,
            getProjects,
            getUser,
            setActiveForm,
            getAdminOrganizations,
            getDispatcherOrganizations
        }
    ),
    lifecycle( {
        async componentWillMount()
        {
            const {
                match,
                getRequestById,
                getProjects,
                getUser,
                getAdminOrganizations,
                getDispatcherOrganizations
            } = this.props;

            getProjects();
            getAdminOrganizations();
            getDispatcherOrganizations();
            getRequestById( match.params.id );
            getUser();
        }
    } )
)( RequestDetail );



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestDetail.js